import { render, staticRenderFns } from "./PsinAddEditIn.vue?vue&type=template&id=000b8708&scoped=true&"
import script from "./PsinAddEditIn.vue?vue&type=script&lang=js&"
export * from "./PsinAddEditIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b8708",
  null
  
)

export default component.exports